import {
  and,
  ControlProps,
  isObjectControl,
  RankedTester,
  rankWith,
  schemaMatches
} from '@jsonforms/core'
import { useJsonForms, withJsonFormsControlProps } from '@jsonforms/react'

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const CheckBoxGroupLayoutRenderer = (props: ControlProps) => {
  const { visible, errors } = props
  const { core } = useJsonForms()

  return (
    <>
      {visible && errors && core?.validationMode === 'ValidateAndShow' ? (
        <div
          className='text-danger'
          style={{ marginBottom: '1rem' }}
          data-testid='checkbox-group-error'
        >
          Please select an option
        </div>
      ) : (
        <></>
      )}
    </>
  )
}

export const checkboxGroupLayoutRendererTester: RankedTester = rankWith(
  10,
  and(
    isObjectControl,
    // eslint-disable-next-line
    schemaMatches((schema: { hasOwnProperty: (arg0: string) => any }) =>
      // eslint-disable-next-line no-prototype-builtins
      schema.hasOwnProperty('isCustomCheckboxGroup')
    )
  )
)

export const checkboxGroupLayout = withJsonFormsControlProps(
  CheckBoxGroupLayoutRenderer
)
